import React, { useEffect, useRef, useState } from 'react';
import HashLoader from 'react-spinners/HashLoader';
import ComingSoon from '../components/AppMobile/comingsoon';
import Footer from '../components/Basic/footer/Footer';
import Nav from '../components/Basic/nav/Nav';

const AppMobile  = () => {
  const [loading, setLoading] = useState(true);
  const [activeNav, setActiveNav] = useState('#header');

  const sectionsRef = useRef({
    '#header': null,
    '#about': null,
    '#experience': null,
    '#contact': null,
  });

  useEffect(() => {
    setLoading(false);

    const handleScroll = () => {
      const scrollPosition = window.scrollY;

      const sections = Object.keys(sectionsRef.current);
      sections.forEach((section) => {
        const sectionElement = sectionsRef.current[section];
        if (sectionElement) {
          const sectionOffset = sectionElement.offsetTop;
          const sectionHeight = sectionElement.offsetHeight;
          if (scrollPosition >= sectionOffset && scrollPosition < sectionOffset + sectionHeight) {
            setActiveNav(section);
          }
        }
      });
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      {loading ? (
        <div className="loading">
          <HashLoader color={'#4db5ff'} size={50} className="loader" />
        </div>
      ) : (
        <div>
          <Nav/>
          <ComingSoon/>
          <Footer />
        </div>
      )}
    </>
  );
};

export default AppMobile;
